// extracted by mini-css-extract-plugin
export default {"icons":"PriceCards_icons__Fc6O4","greyText":"PriceCards_greyText__Hhw8U"};